// @flow

import configureEshopComponents from './configureEshopComponents';

export default (props) => {
    switch (props.decorator || props.is) {
        case 'AddSvgIconSprite':
            return import('./components/AddSvgIconSprite');
        case 'PrintPage':
            return import('fg-frontend/src/components/PrintPage');
        case 'PrintPdf':
            return import('fg-frontend/src/components/PrintPdf');
        case 'RangeDatepicker':
            return import('fg-frontend/components/RangeDatepicker');
        case 'RadioSelect':
        case 'CheckboxSelect':
            return import('fg-frontend/src/components/RadioSelect');
        case 'SimpleCollapse':
            return import('fg-frontend/components/SimpleCollapse');
        case 'Typeahead':
            return import('fg-frontend/components/Typeahead');
        case 'SelectDesign':
            return import('./components/SelectDesign');
        case 'ShowMorePhotos':
            return import('./components/ShowMorePhotos');
        case 'ListToggle':
            return import('fg-frontend/components/ListToggle');
        case 'PasswordToggle':
            return import('fg-frontend/components/PasswordToggle');
        case 'SocialShare':
            return import('fg-frontend/components/SocialShare');
        case 'AnchorsList':
            return import('fg-frontend/src/components/AnchorsList');
        case 'Slider':
            return import('fg-frontend/components/Slider');
        case 'RadioSelectTab':
            return import('fg-frontend/src/components/RadioSelectTab');
        case 'NumberInput':
            return import('fg-frontend/components/NumberInput');
        case 'UniversalPaginationButton':
            return import('fg-frontend/components/UniversalPaginationButton');
        case 'Tooltip':
            return import('./components/Tooltip');
        case 'ContactUsToggler':
            return import('./components/ContactUsToggler');
        case 'GoogleMap':
            return import('./components/GoogleMap');
        case 'GoogleMapTilers':
            return import('./components/GoogleMapTilers');
        case 'GtmHandler':
            return import('./components/GtmHandler');
        case 'CustomGtmHandler':
            return import('./components/CustomGtmHandler');
        case 'TriggerInViewport':
            return import('./components/TriggerInViewport');
        case 'FilterListSelect':
            return import('./components/FilterListSelect');
        case 'FilterListRadio':
            return import('./components/FilterListRadio');
        case 'InteractiveMotive':
            return import('./components/InteractiveMotive');
        case 'Header':
            return import('./components/Header');
        case 'FulltextAnchors':
            return import('./components/FulltextAnchors');
        case 'GoogleRecaptcha':
            return import('fg-frontend/src/components/GoogleRecaptcha');
        case 'Faq':
            return import('./components/Faq');
        case 'PhotoSwipe':
            return import('./components/PhotoSwipe');
        case 'InformationRectangle':
            return import('./components/InformationRectangle');
        case 'EcologySlider':
            return import('./components/EcologySlider');
        case 'HPSlider':
            return import('./components/HPSlider');
        case 'ZigZagWithExtendedContent':
            return import('./components/ZigZagWithExtendedContent');
        case 'AnimateInViewport':
            return import('./components/AnimateInViewport');
        case 'PreventDoubleClickHandler':
            return import('fg-frontend/src/components/PreventDoubleClickHandler');
        case 'GalleryStripeSlider':
            return import('./components/GalleryStripeSlider');
        case 'SocialNetwork':
            return import('./components/SocialNetwork');
        case 'SocialNetworkGallery':
            return import('./components/SocialNetworkGallery');
        default:
            const eshopComponent = configureEshopComponents(props);
            if (eshopComponent) {
                return eshopComponent;
            }
            else {
                console.log(`Unknown component ${props.decorator || props.is}`);
                return null;
            }
    }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js